import * as Yup from 'yup';

const formOptions = {
    email: {
        required: true
    },
    password: {
        required: true
    }
};

const getValidationSchema = () => {
    return Yup.object().shape({
        email: Yup.string().required('mandatory_field').email('invalid_email'),
        password: Yup.string().required('mandatory_field')
    });
};

export default {
    formOptions,
    getValidationSchema
};
